import { Badge } from '@mantine/core';
import { CheckCircle } from 'react-feather';

/**
 * MED-1040 / MED-1085 — the green outlined "Session Complete" pill shown beside
 * the title on the post-session pages. Extracted from PostSessionPageHeader so
 * the three post-session pages can pass it into FullContentHeader's `accessory`
 * slot (the post-session "phase accessory").
 */
export function SessionCompleteBadge() {
  return (
    <Badge
      size="lg"
      radius="xl"
      variant="outline"
      color="medleyGreen"
      leftSection={<CheckCircle size={14} />}
      styles={{
        root: { backgroundColor: 'var(--mantine-color-medleyGreen-0)' },
        label: { textTransform: 'none', fontWeight: 600 },
      }}
      data-testid="session-complete-pill"
    >
      Session Complete
    </Badge>
  );
}

export default SessionCompleteBadge;
